

















































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import { VueEditor } from "vue2-editor";
import _ from "lodash";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import SaleOrderRequestDetail from "../../../store/entities/sale-order-request/sale-order-request-detail";
import AppConsts from "@/lib/appconst";

class PageSalesOrderLineRequest extends PageRequest {
  sku: string;
}
@Component({
  components: { "vue-editor":  VueEditor },
})
export default class CreateSalesOrder extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Object, default: new SaleOrderRequestDetail() })
  salesOrderRequest: SaleOrderRequestDetail;
  maximumFractionDigits = AppConsts.maximumFractionDigits;
  pagerequest: PageSalesOrderLineRequest = new PageSalesOrderLineRequest();
  salesOrderValidLines: Array<any> = new Array<any>();
  salesOrderValidLinesPerPage: Array<any> = new Array<any>();
  filterTotalCount: number = 0;
  spinShow: boolean = false;
  shippingServiceCode: string = null;
  tplCode: string = null;
  tpl = { totalWeight: null, totalVolume: null };
  tplLoading: boolean = false;
  tpls = [];
  titleName = AppConsts.permissionNames.createSalesOrder;
  totalVolume = 0;
  totalWeight = 0;
  salesOrderLines = [];
  shortedQty = false;
  selectedItems = [];
  get shippingServices() {
    var re = this.$store.state.client.clientShippingServices;
    return re;
  }
  get tenant() {
    return this.$store.state.session.tenant;
  }
  get warehouseCode() {
    return this.tenant.tenancyName;
  }
  searchTpl_OnPress = _.debounce(this.searchTpls, AppConsts.debounceDelayTime, {
    leading: false,
    trailing: true,
  });
  async searchTpls(keyword) {
    if (Util.isEmpty(keyword)) return;
    this.tplLoading = true;
    this.$store
      .dispatch({
        type: "tpl/searchTplForSelect",
        data: {
          keyWord: keyword,
        },
      })
      .then((result) => {
        this.tpls = result;
        this.tplLoading = false;
      });
  }
  changeTpl() {
    if (_.isNil(this.tplCode) || _.isEmpty(this.tplCode)) {
      this.tpl = { totalWeight: null, totalVolume: null };
    } else {
      var selectedTpl = this.tpls.find((i) => i.id === this.tplCode);
      this.tpl = {
        totalWeight: selectedTpl.weight,
        totalVolume: selectedTpl.volume,
      };
    }
  }
  getCustomerDefaultTpl() {
    if (
      _.isNil(this.salesOrderRequest.customerId) ||
      this.salesOrderRequest.customerId <= 0
    ) {
      return null;
    } else {
      this.$store
        .dispatch({
          type: "customer/defaultTpl",
          data: {
            id: this.salesOrderRequest.customerId,
          },
        })
        .then(async (result) => {
          if (!_.isNil(result)) {
            this.tplCode = result.id;
            this.tpls.unshift(result);
            this.changeTpl();
          }
        });
    }
  }
  async getSalesOrderLines() {
    this.$store
      .dispatch({
        type: "saleOrder/getSalesOrderLineForCreate",
        data: {
          soRequestId: this.salesOrderRequest.id,
        },
      })
      .then(async (result) => {
        this.salesOrderLines = result;
        await this.buildSoLinesInfo();
      });
  }
  async changeProductQty(row: any, index: number) {
    this.spinShow = true;
    var item = this.salesOrderValidLinesPerPage[index];
    var newValue = _.min([row.orderQty, item.remainOrderQty]);
    if (_.isNil(newValue) || newValue < 0) {
      this.spinShow = false;
      return;
    }
    await this.$store
      .dispatch({
        type: "saleOrder/checkProductInventories",
        data: {
          productId: item.productId,
          orderQty: newValue,
          assetTypeCode: item.assetTypeCode,
          conditionTypeCode: item.conditionTypeCode,
        },
      })
      .then((checkResult) => {
        if (_.isNil(checkResult)) {
          newValue = 0;
        }
        if (
          !_.isNil(checkResult) &&
          (_.isNil(checkResult.enoughInv) || !checkResult.enoughInv)
        ) {
          var validQty = _.min([newValue, item.remainOrderQty]);
          if (
            !_.isNil(checkResult.productInventories) &&
            checkResult.productInventories.length > 0
          ) {
            var productInfo = _.find(checkResult.productInventories, function(
              p
            ) {
              return (
                p.productId === item.productId &&
                p.assetTypeCode === item.assetTypeCode &&
                p.conditionTypeCode === item.conditionTypeCode
              );
            });

            validQty =
              _.isNil(productInfo) ||
              _.isNil(productInfo.maxQty) ||
              productInfo.maxQty <= 0
                ? 0
                : _.min([productInfo.maxQty, item.remainOrderQty]);
          }
          if (validQty <= 0) {
            Util.showNoticeErrorMsg(this, Util.L("Error.UspSoOnhandCheck2"));
          }
          newValue = validQty;
        }
        this.salesOrderValidLinesPerPage[index].orderQty = newValue;
        var line = this.salesOrderValidLines.find(
          (i) => i.productId === item.productId && i.id === item.id
        );
        line.orderQty = newValue;
        row.orderQty = newValue;
        this.getTotalVolume();
        this.getTotalWeight();
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {
        this.spinShow = false;
      });
  }
  async save() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.CreateSalesOrder"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        var lines = _.filter(this.salesOrderValidLines, function(x) {
          return !_.isNil(x.orderQty) && x.orderQty > 0;
        }).map((item) => {
          return {
            lineNumber: item.id,
            productId: item.productId,
            sku: item.sku,
            orderQty: item.orderQty,
            assetTypeCode: this.salesOrderRequest.assetTypeCode,
            conditionTypeCode: this.salesOrderRequest.conditionTypeCode,
            toReqLineNumber: item.toReqLineNumber,
          };
        });
        if (_.isNil(lines) || lines.length <= 0) {
          Util.showNoticeErrorMsg(this, Util.L("Error.NoDetail"));
          this.spinShow = false;
          return;
        }
        await this.$store
          .dispatch({
            type: "saleOrder/create",
            data: {
              shippingServiceCode: this.shippingServiceCode,
              soRequestId: this.salesOrderRequest.id,
              note: this.salesOrderRequest.note,
              shippingNote: this.salesOrderRequest.shippingNote,
              packingNote: this.salesOrderRequest.packingNote,
              tplCode: this.tplCode,
              items: lines,
            },
          })
          .then((result) => {
            Util.showSuccessMsg(this, "Success.CreateSalesOrder");
            this.reset();
            (this.$refs.salesOrderForm as any).resetFields();
            this.$emit("save-success");
            this.$emit("input", false);
            this.salesOrderValidLines = [];
            this.totalVolume = 0;
            this.totalWeight = 0;
          })
          .finally(() => {
            this.spinShow = false;
          });
      },
    });
  }
  cancel() {
    this.reset();
    (this.$refs.salesOrderForm as any).resetFields();
    this.$emit("input", false);
  }
  reset() {
    this.pagerequest = new PageSalesOrderLineRequest();
    this.salesOrderValidLines = new Array<any>();
    this.salesOrderValidLinesPerPage = new Array<any>();
    this.shortedQty = false;
    this.salesOrderLines = [];
    this.filterTotalCount = 0;
  }
  onSelect(selection, row) {
    this.$emit("on-select", selection, row);
  }
  onSelectCancel(selection, row) {
    this.$emit("on-select-cancel", selection, row);
  }
  onSelectAll(selection) {
    this.$emit("on-select-all", selection);
    _.forEach(this.list, (o) => {
      o._checked = true;
    });
    this.selectedItems = this.list;
  }
  onSelectionChange(selection) {
    this.$emit("on-selection-change", selection);
    _.forEach(this.list, (o) => {
      var itemSelected = _.find(selection, function(x) {
        return x.id === o.id;
      });
      if (itemSelected) {
        o._checked = true;
      } else {
        o._checked = false;
      }
    });
    this.selectedItems = this.list.filter((item) => item._checked);
  }
  deleteLines() {
    var deleteIds = _.map(this.selectedItems, (i) => i.id);
    _.remove(this.salesOrderValidLines, function(obj) {
      return deleteIds.includes(obj.id);
    });
    this.searchLines();
  }
  searchLines() {
    this.$store.commit(`saleOrder/setCurrentPage`, 1);
    this.getpage();
  }
  // sale order line
  get list() {
    var re = this.salesOrderValidLinesPerPage;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }

  get loading() {
    return this.$store.state.saleOrder.loading;
  }

  pageChange(page: number) {
    this.$store.commit("saleOrder/setCurrentPage", page);
    this.getpage();
  }

  pagesizeChange(pagesize: number) {
    this.$store.commit("saleOrder/setPageSize", pagesize);
    this.getpage();
  }

  getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters
    this.pagesalesOrderValidLinesChange();
  }

  pagesalesOrderValidLinesChange() {
    var items = this.salesOrderValidLines;
    if (
      !Util.isNull(this.pagerequest.sku) &&
      !Util.isEmpty(this.pagerequest.sku)
    ) {
      items = items.filter(
        (item) => item.sku.indexOf(this.pagerequest.sku) >= 0
      );
    }
    if (this.shortedQty) {
      items = items.filter(
        (item) => item.availableQty - (item.qty - item.soQty) < 0
      );
    }
    this.filterTotalCount = items.length;
    this.salesOrderValidLinesPerPage = Util.pagingItems(
      items,
      this.pageSize,
      this.currentPage
    );
  }

  get pageSize() {
    return this.$store.state.saleOrder.pageSize;
  }

  get totalCount() {
    return this.filterTotalCount;
  }

  get currentPage() {
    return this.$store.state.saleOrder.currentPage;
  }
  async buildSoLinesInfo() {
    if (_.isNil(this.salesOrderLines) || this.salesOrderLines.length <= 0)
      return;
    var soLines = _.map(this.salesOrderLines, function(x) {
      return {
        orderNo: 0,
        id: x.soRequestLineNumber,
        sku: x.sku,
        productId: x.productId,
        productName: x.productName,
        unit: x.unit,
        exportBrandName: x.exportBrandName,
        assetTypeCode: x.assetTypeCode,
        conditionTypeCode: x.conditionTypeCode,
        qty: x.qty,
        soQty: x.soQty,
        handoverQty: x.handoverQty,
        orderQty: _.min([x.orderQty, x.availableQty]),
        note: x.note,
        remainOrderQty: Number(_.min([x.orderQty, x.availableQty])).toFixed(2),
        volume: x.volume,
        weightKg: x.weightKg,
        availableQty: x.availableQty,
        toReqLineNumber: x.toReqLineNumber,
      };
    });
    this.salesOrderValidLines = soLines;
    this.getpage();
    this.getTotalVolume();
    this.getTotalWeight();
  }
  async visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.spinShow = true;
      try {
        this.spinShow = false;
        this.$store
          .dispatch({
            type: "client/getClientShippingServices",
            data: this.salesOrderRequest.clientCode,
          })
          .then((result) => {
            var re = this.$store.state.client.clientShippingServices;
            this.shippingServiceCode = re.length === 0 ? "" : re[0].id;
          });
        await this.getSalesOrderLines();
        this.getCustomerDefaultTpl();
      } catch (error) {
        this.spinShow = false;
      }
    }
  }
  async created() {}
  get sumLineQty() {
    return _.sumBy(this.salesOrderValidLinesPerPage, function(o) {
      return o.qty;
    });
  }
  get sumLineHandoverQty() {
    return _.sumBy(this.salesOrderValidLinesPerPage, function(o) {
      return o.handoverQty;
    });
  }
  get sumLineSoQty() {
    return _.sumBy(this.salesOrderValidLinesPerPage, function(o) {
      return o.soQty;
    });
  }
  getTotalVolume() {
    if (
      _.isNil(this.salesOrderValidLines) ||
      this.salesOrderValidLines.length <= 0
    )
      return 0;
    this.totalVolume = _.size(this.salesOrderValidLines) > 0 ? _.sumBy(this.salesOrderValidLines, function(o) {
      return o.orderQty > 0 ? o.orderQty * o.volume : 0;
    }) : 0;
  }
  getTotalWeight() {
    if (
      _.isNil(this.salesOrderValidLines) ||
      this.salesOrderValidLines.length <= 0
    )
      return 0;
    this.totalWeight = _.size(this.salesOrderValidLines) > 0 ? _.sumBy(this.salesOrderValidLines, function(o) {
      return o.orderQty > 0 ? o.orderQty * o.weightKg : 0;
    }) : 0;
  }
  rowLineClassName(row, index) {
    if (row.availableQty - (row.qty - row.soQty) >= 0) return "";
    return "redRowClass";
  }
  get columns() {
    return [
      {
        type: "selection",
        width: 60,
        align: "center",
        key: "_checked",
      },
      {
        title: Util.L("Order"),
        width: 60,
        key: "orderNo",
      },
      {
        title: Util.L("Sku"),
        width: 150,
        key: "sku",
      },
      {
        title: Util.L("ProductName"),
        width: 200,
        key: "productName",
      },
      {
        title: Util.L("ExportBrandName"),
        width: 200,
        key: "exportBrandName",
      },
      {
        title: Util.L("Unit"),
        width: 100,
        key: "unit",
      },
      {
        title: Util.L("SL có thể tạo YCXK"),
        width: 100,
        key: "availableQty",
      },
      {
        title: Util.L("OrderQty"),
        width: 100,
        slot: "orderQty",
      },
      {
        title: `${Util.L("Qty")} (${this.sumLineQty})`,
        key: "qty",
        width: 80,
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.qty));
        },
      },
      {
        title: `${Util.L("SoQty")} (${this.sumLineSoQty})`,
        key: "soQty",
        width: 120,
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.soQty));
        },
      },
      {
        title: `${Util.L("HandoverQty")} (${this.sumLineHandoverQty})`,
        key: "handoverQty",
        width: 120,
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.handoverQty));
        },
      },
      {
        title: Util.L("Note"),
        width: 120,
        key: "note",
      },
    ];
  }
  salesOrderRule = {
    shippingServiceCode: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("ShippingService")
        ),
        trigger: "blur",
      },
    ],
  };
}
